<!-- Body -->
<div class="page-container">
    <app-header title="{{ 'settings.billing.header' | translate }}" [menuService]="settingsMenuService"></app-header>

    <div *ngIf="customer; else noCustomer" class="profile-layout reverse">
        <div class="profile-layout-content">
            <!-- Overview -->
            <app-subscription-overview
                [subscriptions]="subscriptions"
                [products]="products"
                (edit)="moduleSelectorModal.show()"
                (cancel)="onCancelModule($event)"
            ></app-subscription-overview>
            <!-- Invoices -->
            <app-invoice-overview [subscriptions]="subscriptions" [invoices]="invoices"></app-invoice-overview>
        </div>
        <div class="profile-layout-sidebar">
            <!-- Payment Info -->
            <app-payment-information [cards]="cards" (edit)="paymentInformationModal.show()"></app-payment-information>
            <!-- Cancellation -->
            <ui-card>
                <ui-button type="primary" (click)="subscriptionCancellationModal.show()">
                    {{ 'settings.subscription-cancellation.cancelButton' | translate }}
                </ui-button>
            </ui-card>
        </div>
    </div>
    <ng-template #noCustomer>
        <ui-card>
            <app-segment-header title="{{ 'settings.billing.noCustomerHeader' | translate }}"></app-segment-header>
            <div [innerHTML]="'settings.billing.noCustomerMessage' | translate"></div>
        </ui-card>
    </ng-template>
</div>

<!-- Cancellation Dialog -->
<app-deprecated-confirmation-dialog
    #confirmation
    [title]="'settings.billing.confirmCancelSubscriptionHeader' | translate"
    [description]="'settings.billing.confirmCancelSubscriptionMessage' | translate"
    [negative]="true"
    [label]="'settings.billing.confirmCancelSubscriptionButton' | translate"
></app-deprecated-confirmation-dialog>

<!-- Cancellation Form -->
<app-deprecated-modal-form
    #subscriptionCancellationModal
    (save)="onCancelSubscription(subscriptionCancellationForm)"
    [form]="subscriptionCancellationForm"
    [label]="'settings.billing.cancelSubscriptionFormButton' | translate"
    [headerText]="'settings.billing.cancelSubscriptionFormHeader' | translate"
>
    <app-subscription-cancellation-form #subscriptionCancellationForm> </app-subscription-cancellation-form>
</app-deprecated-modal-form>

<!-- Module Selector Form -->
<app-deprecated-modal-form
    #moduleSelectorModal
    (save)="onModuleSelectorSave(moduleSelectorForm)"
    [form]="moduleSelectorForm"
    [label]="'settings.billing.subscribeDialogButton' | translate"
    [headerText]="'settings.billing.subscribeDialogHeader' | translate"
>
    <app-module-selector-form #moduleSelectorForm [products]="products" [subscriptions]="subscriptions">
    </app-module-selector-form>
</app-deprecated-modal-form>

<!-- Payment Information Form -->
<app-deprecated-modal-form
    #paymentInformationModal
    [thin]="true"
    [form]="paymentInformationForm"
    (save)="onPaymentInformationSave(paymentInformationForm)"
    headerText="{{ 'settings.billing.paymentInfoDialogHeader' | translate }}"
>
    <app-payment-information-form #paymentInformationForm> </app-payment-information-form>
</app-deprecated-modal-form>
